import React from 'react';
import { IMAGES_REPO } from '../../../config';

const ComponentView = (props) => {
  const { isSelected, body, description, name, photo, type } = props;
  return (
    <div className={isSelected ? `team-person-view team-person-view--${type} team-person-view--selected` : `team-person-view team-person-view--${type}`}>
      {
        type === 'person' ?
          <div>
            <div className="team-person-view__title">
              <h2>{name}</h2><h3>{description}</h3>
            </div>
            <div className="team-person-view__image-container">
              <img src={IMAGES_REPO + '' + photo}/>
            </div>
            <div className="team-person-view__body" dangerouslySetInnerHTML={{ __html: body }}/>
          </div>
          :
          <div>{name}</div>
      }
    </div>
  );
};

export default ComponentView



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/TeamMember.js